import { render, staticRenderFns } from "./profile_edit.vue?vue&type=template&id=bdf568c2&"
import script from "./profile_edit.vue?vue&type=script&lang=js&"
export * from "./profile_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports